export default {
  'Congratulations!': 'Congratulations!',
  'Application Approved': 'Application Approved',
  'Review Rejected': 'Review Rejected',
  'This Merchant has been onboarded.': 'This Merchant has been onboarded.',
  'Welcome to the Network Family!': 'Welcome to the Network Family!',
  "You're now fully set up to take payments through Network International.":
    "You're now fully set up to take payments through Network International.",
  'If you wish to discuss any aspects of your services, please contact us via the details within your welcome kit email.':
    'If you wish to discuss any aspects of your services, please contact us via the details within your welcome kit email.',
  'Application approved!': 'Application approved!',
  'Welcome to the Network family.': 'Welcome to the Network family.',
  'We will soon be sending you our welcome kit which will explain the next steps to enable you to start taking payments.':
    'We will soon be sending you our welcome kit which will explain the next steps to enable you to start taking payments.',
  'Please contact us via our <1>Contact us</1> page if you need any support or have any questions.':
    'Please contact us via our <1>Contact us</1> page if you need any support or have any questions.',
  'Submit Manual Onboarding': 'Submit Manual Onboarding',
  'Would you like to submit manual onboarding to complete the company application?':
    'Would you like to submit manual onboarding to complete the company application?',
  'Manual onboarding': 'Manual onboarding',
  'Please perform required the manual onboarding steps and confirm the merchant onboarding completion.':
    'Please perform required the manual onboarding steps and confirm the merchant onboarding completion.',
  'Confirm completion': 'Confirm completion',
  'We are sorry to say that merchant’s application has not been successful this time':
    'We are sorry to say that merchant’s application has not been successful this time',
  'If you wish to discuss with us, please <1>contact us</1>.':
    'If you wish to discuss with us, please <1>contact us</1>.',
  'We need more information': 'We need more information',
  'Thank you for your application. We have reviewed the information submitted to us and require some clarifications.':
    'Thank you for your application. We have reviewed the information submitted to us and require some clarifications.',
  "We request you to select 'Update Application' below and review the following details which you provided":
    "We request you to select 'Update Application' below and review the following details which you provided",
  "We request you to select 'Update Application' below and review the following details which you provided:":
    "We request you to select 'Update Application' below and review the following details which you provided:",
  'Update application': 'Update application',
  'Application amendment history': 'Application amendment history',
  Date: 'Date',
  Reason: 'Reason',
  'This  application was declined.': 'This  application was declined.',
  Proceed: 'Proceed',
  'Automated onboarding is in progress': 'Automated onboarding is in progress',
  'This application has been successfully approved and the merchant onboarding is in progress. Please wait.':
    'This application has been successfully approved and the merchant onboarding is in progress. Please wait.',
  'Automated onboarding failed': 'Automated onboarding failed',
  'This application was failed to be registered in back office systems. Please contact technical support and proceed with manual onboarding.':
    'This application was failed to be registered in back office systems. Please contact technical support and proceed with manual onboarding.',
  'This application was failed to be registered in back office systems due to connection error. Retry the registration to proceed.':
    'This application was failed to be registered in back office systems due to connection error. Retry the registration to proceed.',
  Retry: 'Retry',
  'Automated onboarding errors': 'Automated onboarding errors',

  // New merchant completion screen
  'You have been approved!': 'You have been approved!',
  'Your application number.': 'Your application number.',
  'What Happens Next': 'What Happens Next',
  'Instructions for setting up your selected products have been emailed to you.':
    'Instructions for setting up your selected products have been emailed to you.',
  'If we need any additional info, we will contact you within 2 business days.':
    'If we need any additional info, we will contact you within 2 business days.',
  'Have any questions? Feel free to call us at': 'Have any questions? Feel free to call us at',
  'Go to Dashboard': 'Go to Dashboard',
  Copied: 'Copied',
  Copy: 'Copy',
};
